import {useSelector} from "react-redux";
import SvgIcon from "../svg-icon";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {decrypt, encrypt} from "../../helpers/encryption";
import InstrumentIcon from "../instrument-icon";
import associateServices from "../../services";
import store from "../../reducers/createReducers";
import AuthenticationActions from "../../actions/authentication-actions";
import Intercom, {show, update} from '@intercom/messenger-js-sdk';
import {toast} from "react-toastify";
import InformationToast from "../toast/InformationToast";
import stringHelper from "../../helpers/string-helper";


const casinoTypes = [
    {
        language: "footer.casino.slots",
        path: "/casino/slots"
    },
    {
        language: "footer.casino.live-casino",
        path: "/live-casino"
    },
    {
        language: "footer.casino.exclusive",
        path: "/casino/category/exclusive"
    },
    {
        language: "sidebar.virtual_sports",
        path: "/casino/virtual_sports"
    },
]

const sportTypes = [
    {
        language: "footer.sportsbook.sportsbook",
        path: "/sportsbook"
    },
    {
        language: "sidebar.football",
        path: "/sportsbook/football"
    },
    {
        language: "sidebar.basketball",
        path: "/sportsbook/basketball"
    },
    {
        language: "sidebar.american-football",
        path: "/sportsbook/american-football"
    },
    {
        language: "sidebar.baseball",
        path: "/sportsbook/baseball"
    },
    {
        language: "sidebar.tennis",
        path: "/sportsbook/tennis"
    },
    {
        language: "footer.sportsbook.volleyball",
        path: "/sportsbook/volleyball"
    },

]

const currencies = [
    'TRY',
    'BTC',
    'ETH',
    'USDT',
    'BNB',
    'TRX',
    'XRP',
    'DOGE',
    'LTC',
    'USDC',
    'LINK',
    'SHIB',
    'AVAX',
    'ADA'

]
const Footer = () => {
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const {user, authenticated, selectedWallet, navigateHome} = useSelector(state => state.authenticationReducer)
    const {activeLanguage, configuration, agent, theme} = useSelector(state => state.globalReducer)
    const {scriptsR} = useSelector(state => state.dataReducer)

    const [scripts, setScripts] = useState([])
    useEffect(() => {
        setScripts(scriptsR[theme] || [])
    }, [scriptsR, theme])

    const [conversion, setConversion] = useState({
        code: '',
        conversion: ''
    })

    const [comm100Loaded, setComm100Loaded] = useState(false)
    const navigate = useNavigate()
    const [policies, setPolicies] = useState([])
    const [showMe, setShowMe] = useState(true)
    const location = useLocation()

    useEffect(() => {
        if (navigateHome) {
            store.dispatch(AuthenticationActions.navigateToHomepage(false))
            navigate(stringHelper.getLocalizedPath(currentLanguage, '/'))
        }
    }, [navigateHome])

    useEffect(() => {
        if (activeLanguage?.key)
            associateServices.getPolicies({
                lang: activeLanguage?.key
            }).then(res => {

                setPolicies(res?.data || [])
            })
    }, [activeLanguage?.key])


    useEffect(() => {
        if (selectedWallet?.code) {

            if (selectedWallet.code === 'USDT') {

                setConversion({
                    code: 'USDT',
                    conversion: '1'
                })
            } else {
                window?.tcpSocket?.emit('fiat:conversion', encrypt({
                    currency: selectedWallet?.code
                }))

                window?.tcpSocket?.on('fiat:conversions', handleFiatConversion)
            }
        }
    }, [window.tcpSocket, window.tcpSocket?.connected, selectedWallet?.code])

    useEffect(() => {

        if (agent?.isMobile && (location?.pathname?.includes('/casino/game/') || location?.pathname?.includes('/play'))) {
            setShowMe(false)
        } else
            setShowMe(true)
    }, [location.pathname, agent])


    // const handleScriptOnLoad = () => {
    //     if (window.Comm100API) {
    //         // The script is loaded, now set comm100Loaded to true
    //         setComm100Loaded(true);
    //     }
    // }

    useEffect(() => {
        // Polling function to check if Comm100API is ready


        const checkComm100Ready = () => {
            if (window.Comm100API && window.Comm100API.loaded) {
                setComm100Loaded(true);  // Comm100API is ready
                clearInterval(pollingInterval);  // Clear the interval once ready
            }
        };

        // Start polling to check when the Comm100API is ready
        const pollingInterval = setInterval(checkComm100Ready, 5000);  // Check every 500ms

        // Cleanup the interval on component unmount
        return () => {
            clearInterval(pollingInterval);
        };
    }, []);


    useEffect(() => {
        if (configuration?.intercom) {
            // Ensure Intercom is booted with the app ID
            Intercom({
                app_id: configuration.intercom,
                hide_default_launcher: agent?.isMobile
            });


            // Cleanup function to shutdown Intercom when component unmounts
            // Clean up by shutting down Intercom on unmount
            return () => {
                if (typeof Intercom === 'function') {
                    Intercom('shutdown');
                    console.log('Intercom shutdown');
                }
            };
        }

    }, [configuration?.intercom, agent?.isMobile]);

    useEffect(() => {

        if (configuration?.intercom) {
            update({
                // app_id: configuration.intercom,
                user_id: user.id || Math.random(), // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
                name: user.username || '', // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
                email: user.email || '', // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
                created_at: user.registration || '', // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
            })
        }
    }, [configuration?.intercom, user?.id])


    useEffect(() => {
        if (configuration?.intercom) {
            if (agent?.isMobile) {
                update({
                    hide_default_launcher: true
                })
            } else {
                update({
                    hide_default_launcher: false
                })
            }


        }

    }, [agent?.isMobile, configuration?.intercom])

    useEffect(() => {
        if (comm100Loaded && user) {
            try {
                window?.Comm100API?.set('livechat.button.isVisible', !agent?.isMobile);

                window?.Comm100API?.on('livechat.chat.minimize', function () {
                    const dd2 = document.getElementById('comm100-container')
                    if (dd2)
                        dd2.style.display = 'none'; // Hide each chat button

                    const chatButtons = document.querySelectorAll('[id^="comm100-button-"]');
                    chatButtons?.forEach((chatButton) => {
                        chatButton.style.display = 'none'; // Hide each chat button
                        chatButton.style.visibility = 'hidden'; // Hide overlay or blocking elements
                    });

                    // Hide potential overlays or other related elements
                    const chatOverlays = document.querySelectorAll('.comm100-livechat-overlay, .comm100-livechat-widget');
                    chatOverlays?.forEach((overlay) => {
                        overlay.style.display = 'none'; // Hide overlay or blocking elements
                        overlay.style.visibility = 'hidden'; // Hide overlay or blocking elements
                    });
                });


                const values = [
                    {
                        name: 'user_id',
                        value: user.id || -1,
                    },
                    {
                        name: 'username',
                        value: `${user.username || "unknown"}`,
                    },
                    {
                        name: 'vip_status',
                        value: `${user.rank || "unknown"}`,
                    },
                    {
                        name: 'wagered',
                        value: user.wagered || 0.00,
                    },
                    {
                        name: 'daily_net_profit',
                        value: user.daily_net_profit || 0.00,
                    },
                    {
                        name: 'weekly_net_profit',
                        value: user.weekly_net_profit || 0.00,
                    },
                    {
                        name: 'monthly_net_profit',
                        value: user.monthly_net_profit || 0.00,
                    },
                    {
                        name: 'lifetime_net_profit',
                        value: user.lifetime_net_profit || 0.00,
                    },
                ];
                window?.Comm100API?.set('livechat.customVariables', values);
            } catch (e) {
                console.error(e)
            }
        }
    }, [comm100Loaded, user, agent?.isMobile]);  // Re-run the effect when Comm100API is ready or user data changes

    useEffect(() => {


        try {
            if (configuration?.license?.func && configuration?.license?.seal_id && configuration?.license?.url) {

                // Check if the script is already loaded
                const existingScript = document.querySelector(`script[src="${configuration.license.url}"]`);

                const initSeal = () => {
                    const wrapper = document.getElementById('licence-wrapper');

                    if (wrapper) {
                        // Clear previous seal if it exists
                        const existingSeal = document.getElementById(`anj-${configuration.license.seal_id}`);
                        if (existingSeal) {
                            wrapper.removeChild(existingSeal);
                        }

                        // Create the new div for the seal
                        const div = document.createElement('div');
                        div.id = `anj-${configuration.license.seal_id}`;
                        div.style.width = '70px';
                        div.style.height = '70px';
                        div.setAttribute('data-anj-seal-id', configuration.license.seal_id);
                        div.setAttribute('data-anj-image-size', '128');
                        div.setAttribute('data-anj-image-type', 'basic-small');

                        wrapper.append(div);

                        // Initialize the seal function
                        const initFunction = window[configuration?.license?.func];

                        if (typeof initFunction?.init === 'function') {
                            initFunction.init();
                        } else {
                            console.error(`Function ${configuration.license.func} not found or is not a function`);
                        }
                    }
                };


                if (!existingScript) {
                    // Create the script dynamically
                    const script = document.createElement("script");
                    script.src = configuration.license.url;
                    script.async = true;
                    document.body.appendChild(script);

                    // Wait until the script is fully loaded before initializing
                    script.onload = () => {
                        initSeal();
                    };

                    script.onerror = () => {
                        console.error(`Failed to load script: ${configuration.license.url}`);
                    };
                } else {
                    // If script is already loaded, directly initialize the seal
                    initSeal();
                }


                // Clean up the div and script when component unmounts or re-renders
                return () => {
                    const sealElement = document.getElementById(`anj-${configuration?.license?.seal_id}`);
                    if (sealElement) {
                        sealElement.remove();
                    }
                    if (existingScript) {
                        existingScript.remove();
                    }
                };
            }
        } catch (e) {
            console.error(e)
        }
    }, [configuration?.license?.func, configuration?.license?.seal_id, configuration?.license?.url]);


    useEffect(() => {


        if (Array.isArray(scripts)) {
            try {
                scripts?.forEach(scriptItem => {


                    // console.log(scriptItem)
                    // Create a temporary div to extract the HTML content
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = scriptItem?.script;

                    // Extract the div element (add to body)
                    const divElement = tempDiv.querySelector('div');
                    if (divElement)
                        document.body.appendChild(divElement);

                    // Extract the script element (add to head)
                    const scriptElement = tempDiv.querySelector('script');
                    if (scriptElement) {
                        const newScript = document.createElement('script');
                        newScript.type = 'text/javascript';
                        newScript.nonce = "randomNonce"; // Set the nonce attribute
                        newScript.innerHTML = scriptElement.innerHTML;

                        // newScript.addEventListener('load', handleScriptOnLoad);
                        document.head.appendChild(newScript);
                    } else {
                        console.log('SCRIPT NOT FOUND')
                    }
                });
            } catch (e) {
                console.error(e)
            }
        } else {
            console.error('Invalid script data');
        }


    }, [scripts])

    const handleFiatConversion = (e) => {
        const data = decrypt(e)
        setConversion({
            code: selectedWallet.code,
            conversion: data.results
        })
    }


    const handleLiveSupport = () => {

        if (window?.Comm100API) {
            try {
                console.log('window?.Comm100API = ', window?.Comm100API)
                window?.Comm100API?.open_chat_window();
            } catch (e) {
                console.error(e)
            }
        } else {
            try {
                show()
            } catch (e) {
                console.error(e)
                alert(e.message)
            }
        }
    }

    const [requestingCall, setRequestingCall] = useState(false)

    const handleCallRequest = () => {
        if (requestingCall)
            return


        setRequestingCall(true)

        associateServices.makeCallRequest({}).then(res => {

            toast(<InformationToast
                icon={'ti-info-circle'}
                title={t(`general.information`)}
                message={t(`api-notifications.${res?.data}`)}
            />)

            setRequestingCall(false)

        })
    }

    if (!showMe)
        return null


    return (

        <footer className="footer" id="footer">
            <div className="footer__content">
                <div className="container">
                    <div className="row footer-desc">
                        <div className="col-6 col-md-4 col-xl-2">
                            <div className="footer__nav">
                                <h6 className="footer__title">{t('footer.casino.title')}</h6>
                                <ul className="footer__list">
                                    {
                                        casinoTypes.map(type => (
                                            <li key={type.language}>
                                                <Link
                                                    to={stringHelper.getLocalizedPath(currentLanguage, type.path)}
                                                    // onClick={e => handleNavigate(type.path)}
                                                >{t(type.language)}</Link>
                                            </li>
                                        ))
                                    }


                                </ul>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2">
                            <div className="footer__nav">
                                <h6 className="footer__title">{t('footer.sportsbook.title')}</h6>
                                <ul className="footer__list">
                                    {
                                        sportTypes.map(type => (
                                            <li key={type.language}>
                                                <Link
                                                    to={stringHelper.getLocalizedPath(currentLanguage, type.path)}
                                                    // onClick={e => handleNavigate(type.path)}
                                                >{t(type.language)}</Link>
                                            </li>
                                        ))
                                    }

                                </ul>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2">
                            <div className="footer__nav">
                                <h6 className="footer__title">{t('footer.policies.title')}</h6>
                                <ul className="footer__list">
                                    {
                                        policies?.map(policy =>
                                            <li key={policy.path}>
                                                <Link
                                                    to={stringHelper.getLocalizedPath(currentLanguage, `/policy?tab=${policy.path}`)}>
                                                    {policy.title}</Link>
                                            </li>
                                        )
                                    }


                                </ul>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2">
                            <div className="footer__nav">
                                <h6 className="footer__title">{t('footer.promos.title')}</h6>
                                <ul className="footer__list">
                                    <li>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, `/vip`)}
                                        >{t('footer.promos.vip-club')}</Link>
                                    </li>

                                    <li>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, `/tournaments`)}
                                        >{t('tournaments.title')}</Link>
                                    </li>

                                    <li>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, `/promotions`)}
                                        >{t('promotions.title')}</Link>
                                    </li>
                                    <li>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, `/settings?tab=offers`)}
                                        >{t('footer.promos.redeem-a-promo')}</Link>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2">
                            <div className="footer__nav">
                                <h6 className="footer__title">{t('footer.support.title')}</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a onClick={handleLiveSupport}>{t('footer.support.live-support')}</a>
                                    </li>
                                    <li>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, `/help`)}
                                        >{t('footer.support.help-center')}</Link>
                                    </li>


                                    {
                                        authenticated && configuration?.call_me_able &&
                                        <li className="text-hover">
                                            <span onClick={handleCallRequest}>{t('general.request-call-me')}</span>
                                        </li>
                                    }

                                </ul>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2">
                            <div className="footer__nav">
                                <h6 className="footer__title">{t('footer.community.title')}</h6>
                                <ul className="footer__social">
                                    {
                                        configuration?.facebook &&
                                        <li>
                                            <Link
                                                to={configuration?.facebook} target={'_blank'}>
                                                <SvgIcon id={'facebook'}/>
                                            </Link>
                                        </li>
                                    }
                                    {
                                        configuration?.instagram &&
                                        <li>
                                            <Link to={configuration?.instagram} target={'_blank'}>
                                                <SvgIcon id={'instagram'}/>
                                            </Link>
                                        </li>
                                    }
                                    {
                                        configuration?.twitter &&
                                        <li>
                                            <Link to={configuration?.twitter} target={'_blank'}>
                                                <SvgIcon id={'twitter'}/>
                                            </Link>
                                        </li>
                                    }

                                    {
                                        configuration?.telegram &&
                                        <li>
                                            <Link to={configuration?.telegram} target={'_blank'}>
                                                <SvgIcon id={'telegram'}/>
                                            </Link>
                                        </li>
                                    }


                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">

                            {
                                conversion.conversion && <div className="conversion-wrapper">
                                    <span>1 {conversion.code}</span>
                                    <InstrumentIcon code={conversion?.code}/>
                                    <span>≈ {conversion.conversion} USD</span>
                                </div>
                            }
                            <div className="footer__currencies">
                                <h6 className="footer__title">
                                    <div>
                                        {t('footer.accepted-currencies')}
                                    </div>
                                </h6>
                                <ul className="footer__accepted">
                                    {
                                        currencies?.map(currency =>
                                            <li key={currency}>
                                                <InstrumentIcon code={currency}/>
                                                <span>{currency}</span>
                                            </li>
                                        )
                                    }

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-xxl-2 footer-logo-container">
                            <div className="footer__logo"></div>
                        </div>
                        <div className="col-12 col-md-9 col-xxl-8">
                            <p className="footer__description">
                                {t('footer.description', {
                                    support: configuration?.support
                                })}
                            </p>
                        </div>
                        <div className="col-12 col-md-3 col-xxl-2">
                            <div className="footer__licenses">
                                <ul className="footer__licenses-list">
                                    <li>
                                        {/*<Link*/}
                                        {/*    to={stringHelper.getLocalizedPath(currentLanguage, `/license`)}*/}
                                        {/*>*/}
                                        {/*    <img*/}
                                        {/*        src="https://cdn.ebetlab.com/ebetlab/general/license.png?v=1"*/}
                                        {/*        style={{*/}
                                        {/*            width: 70,*/}
                                        {/*            height: 70,*/}
                                        {/*            objectFit: 'contain',*/}
                                        {/*            marginTop: 8*/}
                                        {/*        }}*/}
                                        {/*        alt=""/>*/}
                                        {/*</Link>*/}

                                        <div id="licence-wrapper">
                                        </div>


                                    </li>
                                    <li>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, `/policy?tab=self-exclusion`)}
                                            style={{
                                                height: 70,
                                                width: 70,
                                            }}>
                                            <SvgIcon extra={'icon18'} id={'18'}/>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>


                    </div>
                    <div className="col-12">
                        <div className="footer__cellar">
                            <ul className="footer__contacts">
                                <li>
                                    {t('footer.support.title')}: <a href={`mailto:${configuration?.support}`}>
                                    {configuration?.support}
                                </a>
                                </li>
                                <li>
                                    {t('footer.partners')}:
                                    <a href={`mailto:${configuration?.affiliate}`}>
                                        {configuration?.affiliate}
                                    </a>
                                </li>
                                <li>
                                    {t('footer.press')}: <a href={`mailto:${configuration?.info}`}>
                                    {configuration?.info}

                                </a>
                                </li>
                            </ul>
                            <small className="footer__copyright">© {configuration?.domain?.toUpperCase()},
                                2024.</small>
                        </div>
                    </div>

                </div>
            </div>
        </footer>

    )

}

export default Footer
